(() => {
  'use strict';

  // The theme editor should show only the storefront's ordinary content.
  if (window.Shopify && window.Shopify.designMode) return;

  const banner = document.querySelector('[data-jl-app-banner]');
  const footer = document.querySelector('[data-jl-app-footer]');
  const dialog = document.getElementById('jl-app-dialog');
  const buttons = Array.from(document.querySelectorAll('[data-jl-app-install]'));
  if (!banner || !footer || !dialog || typeof dialog.showModal !== 'function') return;

  const standalone = window.matchMedia('(display-mode: standalone)');
  const ua = navigator.userAgent;
  const isIOS = /iPhone|iPad|iPod/i.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  const isAndroid = /Android/i.test(ua);
  const isPhone = /iPhone|iPod/i.test(ua) || (isAndroid && /Mobile/i.test(ua));
  const inApp = /FBAN|FBAV|Instagram|Line\/|MicroMessenger|TikTok|Bytedance|Snapchat|; wv\)/i.test(ua);
  const dismissalKey = 'jl-home-screen-banner-dismissed-at';
  const dismissalDuration = 14 * 24 * 60 * 60 * 1000;
  let installPrompt = null;
  let installed = false;
  let dismissedAt = 0;
  let busy = false;
  let dialogTrigger = null;

  // Private browsing and storage restrictions must not break installation.
  try {
    dismissedAt = Number(window.localStorage.getItem(dismissalKey)) || 0;
  } catch (_) { /* Keep the banner available if storage is inaccessible. */ }

  const isStandalone = () => installed || standalone.matches || navigator.standalone === true;
  const refresh = () => {
    const supported = isPhone && !isStandalone();
    footer.hidden = !supported;
    banner.hidden = !supported || (Date.now() - dismissedAt < dismissalDuration);
    if (!supported && dialog.open) dialog.close();
  };

  const showHelp = (trigger) => {
    const kind = inApp ? 'in-app' : isIOS ? 'ios' : isAndroid ? 'android' : 'desktop';
    dialog.querySelectorAll('[data-jl-app-help]').forEach((panel) => {
      panel.hidden = panel.dataset.jlAppHelp !== kind;
    });
    dialogTrigger = trigger;
    if (!dialog.open) dialog.showModal();
  };

  // A browser can supply this event later, after the page becomes installable.
  window.addEventListener('beforeinstallprompt', (event) => {
    if (!isPhone || isStandalone()) return;
    event.preventDefault();
    installPrompt = event;
    refresh();
  });

  window.addEventListener('appinstalled', () => {
    installed = true;
    installPrompt = null;
    refresh();
  });

  if (typeof standalone.addEventListener === 'function') {
    standalone.addEventListener('change', refresh);
  }

  buttons.forEach((button) => {
    button.addEventListener('click', async () => {
      if (!isPhone || isStandalone() || busy) return;
      if (!installPrompt) {
        showHelp(button);
        return;
      }

      // Every browser install event can be used only once.
      const prompt = installPrompt;
      installPrompt = null;
      busy = true;
      buttons.forEach((item) => { item.disabled = true; });
      try {
        const response = await prompt.prompt();
        const result = response || (prompt.userChoice && await prompt.userChoice);
        if (result && result.outcome === 'accepted') {
          installed = true;
        }
      } catch (_) {
        showHelp(button);
      } finally {
        busy = false;
        buttons.forEach((item) => { item.disabled = false; });
        refresh();
      }
    });
  });

  document.querySelector('[data-jl-app-dismiss]').addEventListener('click', () => {
    dismissedAt = Date.now();
    try {
      window.localStorage.setItem(dismissalKey, String(dismissedAt));
    } catch (_) { /* Dismissal still works for this page. */ }
    refresh();
  });

  dialog.addEventListener('close', () => {
    if (dialogTrigger && dialogTrigger.isConnected && !isStandalone()) dialogTrigger.focus();
  });
  dialog.addEventListener('click', (event) => {
    if (event.target !== dialog) return;
    const box = dialog.getBoundingClientRect();
    if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) {
      dialog.close();
    }
  });

  refresh();
})();
